import { render, staticRenderFns } from "./viewFooter.vue?vue&type=template&id=87b5306a&"
import script from "./viewFooter.vue?vue&type=script&lang=js&"
export * from "./viewFooter.vue?vue&type=script&lang=js&"
import style0 from "./viewFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports